/**
 * PayPay決済画面へPOSTリダイレクトを実行する
 * @param {string} startUrl - PayPay決済画面のURL
 * @param {string} accessId - GMO AccessID
 * @param {string} token - GMO Token
 */
export const submitPaymentForm = (startUrl, accessId, token) => {
  const form = document.createElement('form')
  form.method = 'POST'
  form.action = startUrl

  // AccessIDをhiddenフィールドとして追加
  const accessIdInput = document.createElement('input')
  accessIdInput.type = 'hidden'
  accessIdInput.name = 'AccessID'
  accessIdInput.value = accessId
  form.appendChild(accessIdInput)

  // Tokenをhiddenフィールドとして追加
  const tokenInput = document.createElement('input')
  tokenInput.type = 'hidden'
  tokenInput.name = 'Token'
  tokenInput.value = token
  form.appendChild(tokenInput)

  // フォームをDOMに追加してサブミット
  document.body.appendChild(form)
  form.submit()
}
